module.exports=(b,c,d)=>(1-d)*b+d*c;